import type { RoundSummary } from './RoundSummaryPanel.js';
import type { SeatIdentity } from './useSeatIdentity.js';

/**
 * The round summary for the "first to empty their hand scores the others' cards" games (Crazy Eights,
 * Rummy, Colour Dash): the hand's winner gets `+points`, everyone else `+0`; highest total leads.
 */
export function pointsSummary({
  round,
  seats,
  identify,
  totals,
  winner,
  points,
  gameWinner,
  headline,
  human = 'S',
}: {
  readonly round: number;
  readonly seats: readonly string[];
  readonly identify: (seat: string) => SeatIdentity;
  readonly totals: Readonly<Record<string, number | undefined>>;
  readonly winner: string;
  readonly points: number;
  readonly gameWinner: string | null | undefined;
  readonly headline: string;
  readonly human?: string;
}): RoundSummary {
  const top = Math.max(...seats.map((s) => totals[s] ?? 0));
  return {
    round,
    outcome: (gameWinner ?? winner) === human ? 'win' : 'lose',
    headline,
    rows: seats.map((s) => ({
      key: s,
      label: identify(s).name,
      portrait: identify(s).portrait,
      delta: s === winner ? `+${points}` : '+0',
      total: totals[s] ?? 0,
      you: s === human,
      leading: top > 0 && (totals[s] ?? 0) === top,
    })),
    gameOver: Boolean(gameWinner),
  };
}
